// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { locale, Row, Col, Message, Modal, Notice, From, FormItem, Input, Button,
  Card, Form, Icon, Affix, Poptip, Switch, Dropdown, DropdownMenu, DropdownItem, Table,
} from 'iview';
import lang from 'iview/dist/locale/en-US';
import VueScrollTo from 'vue-scrollto';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

import App from './App';
import router from './router';
import NetWorthCard from './components/NetWorthCard';
import REvMarketCard from './components/REvMarketCard';
import PortfolioDistCard from './components/PortfolioDistCard';
import NetWorthIndicator from './components/NetWorthIndicator';

Vue.config.productionTip = false;

Vue.use(VueScrollTo);

// configure language
locale(lang);

// import iview components
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Message', Message);
Vue.component('Modal', Modal);
Vue.component('Notice', Notice);
Vue.component('From', From);
Vue.component('FormItem', FormItem);
Vue.component('Form', Form);
Vue.component('Input', Input);
Vue.component('Card', Card);
Vue.component('Button', Button);
Vue.component('Icon', Icon);
Vue.component('Affix', Affix);
Vue.component('Poptip', Poptip);
Vue.component('i-switch', Switch);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Table', Table);
// Charts
Vue.component('NetWorthCard', NetWorthCard);
Vue.component('REvMarketCard', REvMarketCard);
Vue.component('PortfolioDistCard', PortfolioDistCard);
Vue.component('NetWorthIndicator', NetWorthIndicator);

Raven
.config('https://b2cf8e0ac19a4aaab3204d294ca5b339@sentry.io/1199947', {
  environment: process.env.NODE_ENV,
})
.addPlugin(RavenVue, Vue)
.install();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js